import React, { createContext, useContext, useMemo } from "react"
import { createMemorialAnalytics } from "../analytics/events"
import { createSiteAnalytics } from "../analytics/siteEvents"

// Injection seam for the funeral-ui package. The host supplies runtime config
// (API base URL, mock-data flag) and an analytics transport; this package reads
// no process.env and imports nothing host-specific (e.g. gatsby).
const FuneralUIContext = createContext(null)

const NOOP_TRACK = () => {}

export function FuneralUIProvider({
  apiBaseUrl,
  useMockData = false,
  analytics,
  children,
}) {
  const value = useMemo(() => {
    const track =
      analytics && typeof analytics.track === "function"
        ? analytics.track
        : NOOP_TRACK
    return {
      config: { apiBaseUrl, useMockData: Boolean(useMockData) },
      analytics: {
        memorial: createMemorialAnalytics(track),
        site: createSiteAnalytics(track),
      },
    }
  }, [apiBaseUrl, useMockData, analytics])

  return (
    <FuneralUIContext.Provider value={value}>
      {children}
    </FuneralUIContext.Provider>
  )
}

function useFuneralContext() {
  const ctx = useContext(FuneralUIContext)
  if (!ctx) {
    throw new Error(
      "[@evertech/funeral-ui] Missing <FuneralUIProvider>. Wrap your app " +
        "(e.g. via Gatsby wrapRootElement) before rendering memorial or " +
        "obituaries components."
    )
  }
  return ctx
}

export function useFuneralConfig() {
  return useFuneralContext().config
}

export function useFuneralAnalytics() {
  return useFuneralContext().analytics
}
